module.exports = __webpack_public_path__ + "img/134.a4693ac2.png";